/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseAiTutorFormativeFeedbackData } from './genericApiResponseAiTutorFormativeFeedbackData';
import type { GenericApiResponseAiTutorFormativeFeedbackMessage } from './genericApiResponseAiTutorFormativeFeedbackMessage';
import type { GenericApiResponseAiTutorFormativeFeedbackPagination } from './genericApiResponseAiTutorFormativeFeedbackPagination';
import type { GenericApiResponseAiTutorFormativeFeedbackError } from './genericApiResponseAiTutorFormativeFeedbackError';

export interface GenericApiResponseAiTutorFormativeFeedback {
  data?: GenericApiResponseAiTutorFormativeFeedbackData;
  message?: GenericApiResponseAiTutorFormativeFeedbackMessage;
  pagination?: GenericApiResponseAiTutorFormativeFeedbackPagination;
  error?: GenericApiResponseAiTutorFormativeFeedbackError;
  statusCode?: number;
}
